module.exports = __webpack_public_path__ + "img/agency_thumbnail-600x450.7cdfe7f8.jpg";